import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=2d998ef9"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d998ef9')) {
      api.createRecord('2d998ef9', component.options)
    } else {
      api.reload('2d998ef9', component.options)
    }
    module.hot.accept("./BaseInput.vue?vue&type=template&id=2d998ef9", function () {
      api.rerender('2d998ef9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInput.vue"
export default component.exports